module.exports = __webpack_public_path__ + "odinstatic/v17.0.0/media/pricing.40d2e7bd.svg";